import { sendComscoreBeacon } from '@/libs/comscore';

export const useComscoreTracking = () => {
  // Related Content Click
  const trackContentClick = (contentId) => {
    sendComscoreBeacon({
      name: "content_view",
      c10: contentId,
    });
  };

  // Search / Filter / Sort
  const trackSearch = ({ query, filter, sort }) => {
    sendComscoreBeacon({
      name: "search_results",
      c11: query || "",
      c12: filter || "",
      c13: sort || "",
    });
  };

  return { trackContentClick, trackSearch };
};